import BookSecurelyBanner from './BookSecurelyBanner';

export default BookSecurelyBanner;
